"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props, isCopySuccess) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'popup' : _props$layout;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccSocialShareStyle = (0, _react.useMemo)(function () {
    var mobileLayoutProps = function mobileLayoutProps() {
      if (layout === 'inline' && isMobileView) {
        return {
          height: '100%'
        };
      }
      return {};
    };
    var optionsDeviceProps = function optionsDeviceProps() {
      var gridTemplateColumns = isMobileView ? '1fr' : '1fr 1fr';
      var gap = isMobileView ? pxToRem(16) : pxToRem(20);
      return {
        gridTemplateColumns: gridTemplateColumns,
        gap: gap
      };
    };
    var optionDeviceProps = function optionDeviceProps() {
      var height = isMobileView ? pxToRem(50) : pxToRem(60);
      return {
        height: height
      };
    };
    var optionFeedbackCopiedProps = function optionFeedbackCopiedProps() {
      var opacity = isCopySuccess ? 1 : 0;
      return {
        opacity: opacity
      };
    };
    var ccSocialShare = (0, _css.css)(_objectSpread({}, mobileLayoutProps()));
    var ccSocialShareOptions = (0, _css.css)(_objectSpread({
      display: 'grid',
      paddingTop: pxToRem(20),
      paddingBottom: pxToRem(10)
    }, optionsDeviceProps()));
    var ccSocialShareOption = (0, _css.css)(_objectSpread({
      position: 'relative'
    }, optionDeviceProps()));
    var ccSocialShareOptionInput = (0, _css.css)({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: 'unset',
      opacity: 0,
      pointerEvents: 'none',
      overflow: 'hidden',
      zIndex: -1
    });
    var ccSocialShareOptionFeedback = (0, _css.css)(_objectSpread({
      fontSize: pxToRem(14),
      lineHeight: 1,
      paddingBottom: pxToRem(3),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.success,
      transition: 'opacity 0.5s ease-in-out',
      position: 'absolute',
      top: '0',
      left: 0,
      right: 0,
      transform: 'translate(0, -100%)',
      pointerEvents: 'none',
      userSelect: 'none'
    }, optionFeedbackCopiedProps()));
    var ccSocialShareOptionMask = (0, _css.css)({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100% !important',
      height: '100% !important',
      overflow: 'hidden',
      cursor: 'pointer',
      borderRadius: pxToRem(10),
      iframe: {
        position: 'absolute',
        top: '50% !important',
        left: '50% !important',
        transformOrigin: 'center center',
        transform: 'scale(100)'
      }
    });
    return {
      ccSocialShare: ccSocialShare,
      ccSocialShareOptions: ccSocialShareOptions,
      ccSocialShareOption: ccSocialShareOption,
      ccSocialShareOptionInput: ccSocialShareOptionInput,
      ccSocialShareOptionFeedback: ccSocialShareOptionFeedback,
      ccSocialShareOptionMask: ccSocialShareOptionMask
    };
  }, [isCopySuccess, isMobileView, layout, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.success]);
  return {
    'cc-SocialShare': ccSocialShareStyle.ccSocialShare,
    'cc-SocialShare__options': ccSocialShareStyle.ccSocialShareOptions,
    'cc-SocialShare__option': ccSocialShareStyle.ccSocialShareOption,
    'cc-SocialShare__option__input': ccSocialShareStyle.ccSocialShareOptionInput,
    'cc-SocialShare__option__feedback': ccSocialShareStyle.ccSocialShareOptionFeedback,
    'cc-SocialShare__option__mask': ccSocialShareStyle.ccSocialShareOptionMask
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;